"use strict";
import axios from "axios";
// import baseUrl from "./env"; // 引入baseUrl\
import store from '../store'
import {
  REQUEST_LIST
} from '../common/index'

var dsBridge = require("dsbridge")
// axios.defaults.timeout = 10 * 1000; //设置超时时间
axios.interceptors.request.use(
  (config) => {
    // 拦截器里面配置header参数
    config.headers["Content-Type"] = "application/json;charset=UTF-8";
    let isLoading = config.headers["loadingRequest"]
    let isJosnUrlPort = config.headers['isJosnUrlPort']
    if (isLoading === undefined || isLoading === null) {
      store.dispatch("getLoadingNum", store.state.loadingNum++);
      store.commit("chanLoadingStatus", true);
    } else {
      if (isLoading) {
        store.dispatch("getLoadingNum", store.state.loadingNum++);
        store.commit("chanLoadingStatus", true);
      }
    }
    let company;
    if (config.url === 'cms/cmsGroupAccount/accountSubjectCopy') {
      company = '3'
    } else {
      if (store.state.getHeadInfo.company == '3') {
        if (store.state.getOpenAccount) {
          company = store.state.getOpenAccount.companyId || store.state.getOpenAccount.company
        } else {
          company = store.state.personalAccount.company
        }
      } else {
        company = store.state.getHeadInfo.company || store.state.baseInfoFromNative.company
      }
    }
    if (config.url === 'tms/pub/bundle/booking/fundUpperLimit') {
      config.headers["company"] = company;
    }
    let token = store.state.getHeadInfo.token || store.state.baseInfoFromNative.Authorization
    config.baseURL = getUrl(company,isJosnUrlPort)
    let data = config.url;
    let result = REQUEST_LIST.includes(data)
    if (!result && token) {
      config.headers.Authorization = token 
    }
    config.headers.mobile = store.state.getHeadInfo.mobile ? store.state.getHeadInfo.mobile : ''
    return config;
  },
  (error) => {
    // 隐藏加载
    store.commit("chanLoadingStatus", false);
    store.dispatch("getLoadingNum", 0);
    return Promise.reject(error);
  }
);

function isIos() {
  let u = navigator.userAgent;
  if (u.match(/Mac OS X/i) == 'Mac OS X') {
    return true
  }
}

axios.interceptors.response.use(
  (response) => {
    if (response.data.code === 60002 || response.data.code === 60003) {
      if (isIos()) {
        window.webkit.messageHandlers.InvalidLogin.postMessage("");
      } else {
        window.android.InvalidLogin("0");
      }
    }
    // 隐藏加载
    if (store.state.enforceFlag != '1') {
      store.dispatch("getLoadingNum", store.state.loadingNum--);
      if (store.state.loadingNum < 1) {
        store.commit("chanLoadingStatus", false)
        store.dispatch("getLoadingNum", 0);
      }
    }
    // return response;
    // 调用全局拦截方法处理状态码
    const result = Vue.prototype.$interceptCode(response);
    if( result.intercepted) {
      // 如果被拦截，执行处理函数
      result.handle();
      store.commit("chanLoadingStatus", false);
      store.dispatch("getLoadingNum", 0);
      return Promise.reject({ intercepted: true, code: response.data.code });
    }
    // 如果未被拦截，正常返回响应数据
    return response
  },
  (error) => {
    // 隐藏加载
    store.commit("chanLoadingStatus", false);
    store.dispatch("getLoadingNum", 0);
    return Promise.resolve(error.response);
  }
);

function getUrl(data,isJosnUrlPort) {
  if (data === '1') {
    // return 'http://192.168.10.146:9013/app/shlx'
    // return 'http://192.168.10.127:9013/app/shlx'
    // return 'http://192.168.186.110:9012/app/shlx'
    return isJosnUrlPort?`${process.env.VUE_APP_API_URL}:${isJosnUrlPort}`:`${process.env.VUE_APP_API_URL}:9013/app/shlx` //正式
      //  return 'http://192.168.186.184:9012/app/shlx' //蒋茜
    // return 'http://192.168.186.32:9012/app/shlx' //周鑫
    // return 'http://192.168.10.146:9013/app/shlx'
    // return 'http://192.168.186.25:9012/app/shlx' //范佩江
    // return 'http://lucaizhu.lupuamc.com:9013/app/shlx' //侯
  } else if (data === '2') {
    return `${process.env.VUE_APP_API_URL}:9012/app/hzlp`
  } else if (data === '3') {
    return `${process.env.VUE_APP_API_URL}:9014/app/group`
  } else if (data === '4') {
    return `${process.env.VUE_APP_API_URL}:9015/app/shlp`
  } else if (data === '5') {
    return `${process.env.VUE_APP_API_URL}:9016/app/hzlx`
  } else {
    // return 'http://192.168.186.184:9012/app/shlx' //蒋茜
    return isJosnUrlPort?`${process.env.VUE_APP_API_URL}:${isJosnUrlPort}`:`${process.env.VUE_APP_API_URL}:9013/app/shlx` //正式
    // return `${process.env.VUE_APP_API_URL}:9013/app/shlx` //正式
    // return '/app/shlx' //马涛涛
    // return 'http://192.168.186.225:9013/app/shlx' //周鑫
    // return 'http://192.168.186.110:9012/app/shlx' //蒋茜
    // return 'http://lucaizhu.lupuamc.com:9013/app/shlx'
  }
}

function checkStatus(response) {
  // 如果http状态码正常，则直接返回数据
  if (
    response &&
    (response.status === 200 ||
      response.status === 304 ||
      response.status === 400)
  ) {
    console.log("返参：",response.data)
    return response.data;
  }
  store.commit("chanLoadingStatus", false);
  store.state.loadingNum = 0
  return {
    msg: "网络异常",
  };
}
// get请求方式
export function get(url, data, header) {
  return new Promise((resolve, reject) => {
    if (isMobile()) {
      if(store.state.getHeadInfo.company == '1'){//上海陆享才走国密
        let params = {
          url,
          params: data,
          header,
          method: "1",
        };
        console.log("请求参数国密--get:",header, params.url,params.params)
        if (header) {
          let loading = header["loadingRequest"]
          if (!loading) {
            store.commit("chanLoadingStatus", false);
            store.dispatch("getLoadingNum", 0);
          } else {
            store.dispatch("getLoadingNum", store.state.loadingNum++);
            store.commit("chanLoadingStatus", true);
          }
        } else {
          store.dispatch("getLoadingNum", store.state.loadingNum++);
          store.commit("chanLoadingStatus", true);
        }
        dsBridge.call("nativePost", params, function (responseData) {
          if (isIos()) {
            // console.log("get请求，国密返回的数据---ios")
            console.log("返回数据",params.url,responseData)
            const result = Vue.prototype.$interceptCode(responseData);
            if (result.intercepted) {
              result.handle();
              store.commit("chanLoadingStatus", false)
              store.dispatch("getLoadingNum", 0);
              reject({ intercepted: true, code: response.data.code });
            }
            resolve(responseData);
            if (responseData.code == 10000) {
              store.commit("chanLoadingStatus", false);
              store.dispatch("getLoadingNum", 0);
            }
            // 隐藏加载
            if (store.state.enforceFlag != '1') {
              store.dispatch("getLoadingNum", store.state.loadingNum--);
              if (store.state.loadingNum < 1) {
                store.commit("chanLoadingStatus", false)
                store.dispatch("getLoadingNum", 0);
              }
            }
  
          } else {
            //异步调用
            // console.log("get请求，国密返回的数据---安卓")
            console.log("返回数据",params.url,JSON.parse(responseData).data)
            const result = Vue.prototype.$interceptCode(JSON.parse(responseData));
            if (result.intercepted) {
              result.handle();
              store.commit("chanLoadingStatus", false)
              store.dispatch("getLoadingNum", 0);
              reject({ intercepted: true, code: response.data.code });
            }
            resolve(JSON.parse(responseData).data)
            if (JSON.parse(responseData).data.code == 10000) {
              store.commit("chanLoadingStatus", false);
              store.dispatch("getLoadingNum", 0);
            }
            // 隐藏加载
            if (store.state.enforceFlag != '1') {
              store.dispatch("getLoadingNum", store.state.loadingNum--);
              if (store.state.loadingNum < 1) {
                store.commit("chanLoadingStatus", false)
                store.dispatch("getLoadingNum", 0);
              }
            }
  
          }
        })
      }else{//其他主体不走国密
        axios
        .get(url, {
          params: data,
          headers: header
        })
        .then((response) => {
          resolve(checkStatus(response));
        })
        .catch((err) => {
          reject(err);
        });
      }
    } else {//pc端不走国安加密
      axios
        .get(url, {
          params: data,
          headers: header
        })
        .then((response) => {
          resolve(checkStatus(response));
        })
        .catch((err) => {
          reject(err);
        });
    }

  });

}

//post请求
export function post(url, data, header) {
  return new Promise((resolve, reject) => {
    let params = {
      url,
      params: data,
      header,
      method: "2",
    };

    // console.log("请求的url:", params.url)
    console.log("请求参数--post:", params.url,params.params,header)
    if (header) {
      let loading = header["loadingRequest"]
      if (!loading) {
        store.commit("chanLoadingStatus", false);
        store.dispatch("getLoadingNum", 0);
      } else {
        store.dispatch("getLoadingNum", store.state.loadingNum++);
        store.commit("chanLoadingStatus", true);
      }
    } else {
      //默认有Loading
      store.dispatch("getLoadingNum", store.state.loadingNum++);
      store.commit("chanLoadingStatus", true);
    }
    if (isMobile()) {
      if(store.state.getHeadInfo.company == '1' || store.state.baseInfoFromNative.company == '1'){//上海陆享才走国密
        dsBridge.call("nativePost", params, function (responseData) {
          
          if (isIos()) {
            // console.log("get请求，国密返回的数据---ios")
            console.log("返回数据",params.url,responseData)
            const result = Vue.prototype.$interceptCode(responseData);
            if (result.intercepted) {
              result.handle();
              store.commit("chanLoadingStatus", false)
              store.dispatch("getLoadingNum", 0);
              reject({ intercepted: true, code: response.data.code });
            }
            resolve(responseData);
            if (responseData.code == 10000) {
              store.commit("chanLoadingStatus", false);
              store.dispatch("getLoadingNum", 0);
            }
            // 隐藏加载
            if (store.state.enforceFlag != '1') {
              store.dispatch("getLoadingNum", store.state.loadingNum--);
              if (store.state.loadingNum < 1) {
                store.commit("chanLoadingStatus", false)
                store.dispatch("getLoadingNum", 0);
              }
            }
  
          } else {
            //异步调用
            // console.log("get请求，国密返回的数据---安卓")
            const result = Vue.prototype.$interceptCode(JSON.parse(responseData));
            if (result.intercepted) {
              result.handle();
              store.commit("chanLoadingStatus", false)
              store.dispatch("getLoadingNum", 0);
              reject({ intercepted: true, code: response.data.code });
            }
            resolve(JSON.parse(responseData).data)
            console.log("返回数据",params.url,JSON.parse(responseData).data)
            if (JSON.parse(responseData).data.code == 10000) {
              store.commit("chanLoadingStatus", false);
              store.dispatch("getLoadingNum", 0);
            }
            // 隐藏加载
            if (store.state.enforceFlag != '1') {
              store.dispatch("getLoadingNum", store.state.loadingNum--);
              if (store.state.loadingNum < 1) {
                store.commit("chanLoadingStatus", false)
                store.dispatch("getLoadingNum", 0);
              }
            }
  
          }
        })
      }else{
        axios.post(url, data, {
          headers: header
        }).then(
          (response) => {
            resolve(checkStatus(response));
          },
          (err) => {
            reject(err);
          }
        );
      }


    } else {
      console.log('pc端不走国安加密........................',header)
      axios.post(url, data, {
        headers: header
      }).then(
        (response) => {
          resolve(checkStatus(response));
        },
        (err) => {
          reject(err);
        }
      );
    }


  });
}

//判断是手机还是pc
function isMobile() {
  var system = {};
  system.pingtai = /(Win32|Win16|WinCE|Mac68K|MacIntel|MacIntel|MacPPC|Linux mips64)/i.test(navigator.platform);
  if (system.pingtai) {
    //电脑
    return false
  } else {
    //手机
    return true
  }
}



import Qs from "qs";
export function postFromeDate(url, data) {
  return new Promise((resolve, reject) => {
    axios.post(url, Qs.stringify(data)).then(
      (response) => {
        resolve(checkStatus(response));
      },
      (err) => {
        reject(err);
      }
    );
  });
}